// Mirrors Custom::Macro::ZIMOBI_SYSTEM_KEYS. The dashboard discriminates on this field
// rather than on the macro's name, which the agency is free to rewrite.
export const ZIMOBI_MACRO_SYSTEM_KEYS = {
  VISIT_SCHEDULING: 'visit_scheduling',
};
